import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { PageWrapper, PageWrapperProps } from "../../common-ui/PageWrapper";

import { NetworkErrors, useNetworkById } from "./networkUtils";
import { NetworkIdentifiersView } from "./NetworkIdentifiersEditor";

const pageDetails: PageWrapperProps = {
  className: "Network",
  headerText: "Network"
};

const yesNo = (value?: boolean | null) => (value ? "Yes" : "No");

export const Network = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { network, status, error } = useNetworkById(id);

  if (status === "loading") {
    return (
      <PageWrapper {...pageDetails}>
        <CircularProgress />
      </PageWrapper>
    );
  }

  if (status === "failed" || error) {
    return (
      <PageWrapper {...pageDetails}>
        <h2>{t("Error")}</h2>
        <h3>{t(NetworkErrors.FetchNetworkError)}</h3>
        {error && <p>{error}</p>}
      </PageWrapper>
    );
  }

  if (status === "succeeded" && !network) {
    return (
      <PageWrapper {...pageDetails}>
        <h2>{t(NetworkErrors.NetworkNotFound)}</h2>
      </PageWrapper>
    );
  }

  if (status === "succeeded" && network) {
    return (
      <PageWrapper {...pageDetails}>
        <ul>
          <li>ID: {network.id}</li>
          <li>Name: {network.name}</li>
          <li>Sponsor: {network.sponsor ? network.sponsor.name : "N/A"}</li>
          <li>ACGME Enabled: {yesNo(network.acgmeEnabled)}</li>
          <li>
            All Attending History Disabled:{" "}
            {yesNo(network.allAttendingHistoryDisabled)}
          </li>
          <li>
            Trainee Can Rate Trainee: {yesNo(network.traineeCanRateTrainee)}
          </li>
          <li>Dashboard URL: {network.dashboardURL || "N/A"}</li>
          <li>Show Dashboard Link: {yesNo(network.showDashboardLink)}</li>
          <li>SIMPL 1 ID: {network.simpl1Id ?? "N/A"}</li>
        </ul>
        {network.id && <NetworkIdentifiersView networkId={network.id} />}
        <div>
          <button onClick={() => navigate(`/networks/${network?.id}/edit`)}>
            {t("Edit Network")}
          </button>
        </div>
      </PageWrapper>
    );
  }

  return null;
};
